// @flow
import { connect } from "react-redux";
import type { State } from "../../redux/reducer";

export function mapStateToShowDeposit(state: State) {
  const isIOS = (state.serverData && state.serverData.isIOS) || false;
  const iOSShowDeposit = state.iOSShowDeposit || false;

  const hasRealAcc =
    state.accounts != null
      ? !!state.accounts.find(acc => acc.type === "real") || false
      : false;
  const isIronTrade = process.env.REACT_APP_DEPLOY_TARGET === "irontrade";

  let showDeposit = false;

  if (
    hasRealAcc === true ||
    // - iOS-приложение
    !(
      isIOS === true &&
      // - для irontrade
      isIronTrade === true &&
      // - ключ iOSShowDeposit = false
      iOSShowDeposit === false
    )
  ) {
    showDeposit = true;
  }

  return {
    showDeposit
  };
}

export const withDeposit = connect(mapStateToShowDeposit);



// WEBPACK FOOTER //
// ./src/components/common/withDeposit.js